export const applyScriptFonts = (html) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, "text/html");

  const processNode = (node) => {
    if (node.nodeType === Node.TEXT_NODE) {
      const text = node.nodeValue;

      let result = "";
      let currentScript = null;
      let buffer = "";

      const getScript = (char) => {
        const code = char.codePointAt(0);

        if (code >= 0x0900 && code <= 0x097f) return "hindi";
        if (code >= 0x0a80 && code <= 0x0aff) return "gujarati";
        return "other";
      };

      for (const char of text) {
        const script = getScript(char);

        if (script !== currentScript && buffer.length > 0) {
          if (currentScript === "hindi") {
            result += `<span style="font-family:Gyan_Uni_Bold_Hindi">${buffer}</span>`;
          } else if (currentScript === "gujarati") {
            result += `<span style="font-family:Ghanu_unicode_bold_Guj">${buffer}</span>`;
          } else {
            result += buffer;
          }

          buffer = "";
        }

        currentScript = script;
        buffer += char;
      }

      if (buffer.length > 0) {
        if (currentScript === "hindi") {
          result += `<span style="font-family:Gyan_Uni_Bold_Hindi">${buffer}</span>`;
        } else if (currentScript === "gujarati") {
          result += `<span style="font-family:Ghanu_unicode_bold_Guj">${buffer}</span>`;
        } else {
          result += buffer;
        }
      }

      const span = doc.createElement("span");
      span.innerHTML = result;
      node.replaceWith(span);
    } else if (node.nodeType === Node.ELEMENT_NODE) {
      [...node.childNodes].forEach(processNode);
    }
  };

  processNode(doc.body);

  return doc.body.innerHTML;
};
